// extracted by mini-css-extract-plugin
export default {"icon":"DuplicateClientWarningIcon_icon__UrCRz"};